import { render } from "./search-results.vue?vue&type=template&id=20b2a2c2"
import script from "./search-results.vue?vue&type=script&lang=js"
export * from "./search-results.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Shopify/clients/sneak-fr1/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__